// Fullscreen mobile menu overlay open/close (replaces the inline footer script).
const overlay = document.querySelector('[data-nav-overlay]');
const openBtn = document.querySelector('[data-nav-open]');
const closeBtn = document.querySelector('[data-nav-close]');

if (overlay && openBtn) {
  const open = () => {
    overlay.classList.add('is-open');
    document.body.classList.add('no-scroll');
  };
  const close = () => {
    overlay.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
  };

  openBtn.addEventListener('click', open);
  closeBtn?.addEventListener('click', close);
  overlay.querySelectorAll('a').forEach((a) => a.addEventListener('click', close));
}
